import React, { CSSProperties } from "react";
import "./style.css";

interface SpinnerProps {
  className?: string; // Propriedade opcional
  size?: string; // Propriedade opcional
  borderWidth?: string;
}

type colorTypes = "blue" | "white"
interface LoadingThreeCircleProps {
  style?: CSSProperties | undefined; // Propriedade opcional
  className?: string; // Propriedade opcional
  size?: string; // Propriedade opcional
  color?: colorTypes;
}


const Spinner: React.FC<SpinnerProps> = ({ className, size, borderWidth }) => {
  return (
    <div
      style={{height: size ? size : "20px", width: size ? size : "20px", borderWidth: borderWidth ? borderWidth : "2px"}}
      className={`spinner-border ${className}`} role="status"
    >
        <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export const LoadingThreeCircle: React.FC<LoadingThreeCircleProps> = ({ style, className, size, color }) => {
  return (
    <div className={`loading-indicator loading-indicator-${color || "blue"} ${className}`} style={style}>
      <span style={{ width: size, height: size }}></span>
      <span style={{ width: size, height: size }}></span>
      <span style={{ width: size, height: size }}></span>
    </div>
  );
};

export default Spinner;
